export default {
    new: "New", used: "Used", exrental: "Ex-Rental", exfleet: "Ex-Fleet", mixed: "Mixed"
}